import { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import Dialog from "@mui/material/Dialog";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { CompanyTitledPage } from "../../TitledPage";

import { sendMail } from "../../../features/mail/mail";
import {
  getOrderFormMailSubject,
  getOrderFormMailText,
} from "../../../features/mail/mailTemplate";

import {
  decimalToPercentDecimal,
  getHyphenedDate,
  inputValueToInt,
  isPastDate,
  stringToEmptyIfNull,
} from "../../../utils/utils";

import { grey } from "@mui/material/colors";
import {
  getDisplayOriginWithOther,
  getDisplaySize,
} from "../../../utils/Items";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MenuItem, Select, Switch } from "@mui/material";
import { SYSTEM_PATH_COMPANY, SYSTEM_PATH_CUSTOMER } from "../../../App";
import {
  MSG_ERR_SHIPPING_DATE_NOT_ENTERED,
  MSG_ERR_SHIPPING_DATE_NOT_FOUND,
  MSG_ERR_UNEXPECTED,
} from "../../../common/message";
import DateInput from "../../../components/DateInput";
import ErrorMessageBox from "../../../components/ErrorMessageBox";
import { MailPreviewWithoutMailTo } from "../../../components/MailPreview";
import { SelectDestinationDrawer } from "../../../components/drawers/SelectDestinationDrawer";
import { getListOrderDetail } from "../../../http/api/OrderAPI";
import { postMarketCalendarSearchNextOpenDateInfoAPI } from "../../../http/api/MarketCalendarAPI";
import {
  postMarketPriceSearchTableInfoListAPI,
  postMarketPriceUpdateShippingDateInfoAPI,
} from "../../../http/api/MarketPriceAPI";
import { postMarketPriceShopUsingSearchInfoListAPI } from "../../../http/api/MarketPriceShopUsing";
import { getActualShippingDateInfo } from "../../../utils/shippingDate";
import { getShopsGroupingByCustomer } from "../../../utils/customerShop";
import LoadingModal from "../../../components/LoadingModal";
import { SendFaxDialog } from "./components/sendFaxDalog/OrderFormSendFaxDialog";
import Decimal from "decimal.js";
import { DELIVERY_PRICE_ADDITION_CD_NONE, getDeliveryPriceCalculation, getPrimePrice, getSellingPrice, getUsingDeliveryPrice } from "../../../utils/orderForm";
import { checkIsDeveloper } from "../../../utils/loginUser";
import {stripTrailingZeros} from "../../../utils/decimal";

// 価格表の行の最大数
const maxPriceTableRows = 20;

// 価格表カラム名
const priceTableColumnNames = {
  name: "商品",
  place: "産地",
  size: "規格",
  market_price: "市況価格",
  imformed_price: "案内価格",
  unit_price_per_kilo: "キロ単価",
  prime_price_mark_up_rate: "原価\n値入率",
  prime_price: "原価",
  selling_price_mark_up_rate: "売価\n値入率",
  delivery_price: "納品価格",
  selling_price: "売価",
  unit: "発注単位",
  order_units: "注文数",
  remarks: "備考",
};

const priceTableColumnSx = {
  fontSize: 18,
};

// 市況価格表編集遷移state取得
const getMarketPriceEditLocationState = (marketPriceId, shippingDateInfo, marketPriceHistoryDate, isInitial) => ({
  marketPriceId,
  shippingDateInfo,
  marketPriceHistoryDate,
  isInitial
});

// 取引先側注文編集遷移state取得
const getOrderEditLocationState = (shopId, marketPriceHistoryDate, marketPriceId) => ({ shopId, marketPriceHistoryDate, marketPriceId });

// 表のデータ行1行分
function PriceTableRow({ data, customerShopList, priceTableSetting }) {
  return (
    <TableRow>
      <TableCell
        component="th"
        scope="row"
        sx={{
          ...priceTableColumnSx,
          fontWeight: "bold",
          fontSize: 20,
          height: 28,
          width: "20%",
          minWidth: "220px",
        }}
      >
        {data.displayName}
      </TableCell>
      <TableCell
        sx={{ ...priceTableColumnSx, width: "16%", minWidth: "150px" }}
      >
        {data.displayOrigin}
      </TableCell>
      <TableCell
        sx={{ ...priceTableColumnSx, width: "21%", minWidth: "175px" }}
      >
        {data.displaySize}
      </TableCell>
      <TableCell
        sx={{
          ...priceTableColumnSx,
          width: "10%",
          textAlign: "right",
          minWidth: "120px",
        }}
      >
        {data.isShortage ? "-" : data.marketPrice.toLocaleString()}
      </TableCell>
      {data.isUsingSellingPrice ? (
        <>
          <TableCell
            sx={{
              ...priceTableColumnSx,
              width: "14%",
              textAlign: "right",
              minWidth: "120px",
            }}
          >
            {data.isShortage ? "-" : data.primePriceMarkUpRatePercentage}
          </TableCell>
          <TableCell
            sx={{
              ...priceTableColumnSx,
              width: "14%",
              textAlign: "right",
              minWidth: "120px",
            }}
          >
            {data.isShortage ? "-" : data.primePrice.toLocaleString()}
          </TableCell>
          <TableCell
            sx={{
              ...priceTableColumnSx,
              width: "14%",
              textAlign: "right",
              minWidth: "120px",
            }}
          >
            {data.isShortage ? "-" : data.sellingPriceMarkUpRatePercentage}
          </TableCell>
          <TableCell
            sx={{
              ...priceTableColumnSx,
              width: "14%",
              textAlign: "right",
              minWidth: "120px",
            }}
          >
            {data.isShortage ? "-" : data.sellingPrice.toLocaleString()}
          </TableCell>
        </>
      ) : null}
      {
        data.isUsingDeliveryPrice
        ? <TableCell sx={{...priceTableColumnSx, width:"14%", textAlign: "right", minWidth:"120px"}}>{data.isShortage ? "-" : data.deliveryPrice.toLocaleString() }</TableCell>
        : null
      }
      <TableCell
        sx={{ ...priceTableColumnSx, width: "14%", minWidth: "120px" }}
      >
        {data.orderingUnit}
      </TableCell>
      <TableCell
        sx={{ ...priceTableColumnSx, width: "14%", minWidth: "150px" }}
      >
        {stringToEmptyIfNull(data.remarks)}
      </TableCell>
      {
        // ** 注文締め切り前に注文数を出さない対応
        // getOrderIsLimited()
        //   ? data.shopOrderInfo.map((x)=> (
        //     <TableCell sx={{...priceTableColumnSx,width:"10%", minWidth:"100px",textAlign: "right"}}>{x.orderQuantity}</TableCell>
        //   ))
        //   : null

        customerShopList.map((customerShopInfo, customerIndex) =>
          customerShopInfo.shops.map((shopInfo, shopIndex) => {
            let orderInfo = data.shopOrderInfo.find(
              (shopOrderInfo) => shopOrderInfo.shopId === shopInfo.shopId
            );
            return (
              <TableCell
                sx={{
                  ...priceTableColumnSx,
                  width: "10%",
                  minWidth: "100px",
                  textAlign: "right",
                  borderLeft:
                    customerIndex > 0 && shopIndex === 0
                      ? "1px #dfdfdf solid"
                      : null,
                }}
              >
                {orderInfo && priceTableSetting.isHistoryDateSpecified ? stripTrailingZeros(orderInfo.orderQuantity) : 0}
              </TableCell>
            );
          })
        )
      }
    </TableRow>
  );
}

// 価格表(編集用)
function PriceEditTable({ tableData, listShop, priceTableSetting }) {
  // 単価列名出力設定
  const getUnitColumnName = (priceTableSetting) => {
  	if (priceTableSetting.isUsingDeliveryPrice) {
      return priceTableColumnNames.imformed_price;
    }
    
    return priceTableSetting.unitPriceCd === 2
      ? priceTableColumnNames.unit_price_per_kilo
      : priceTableColumnNames.market_price;
  };

  let customerShopList = getShopsGroupingByCustomer(listShop);

  var lastName = "";
  var lastOrigin = "";

  if (tableData && tableData.length > 0) {
    return (
      <TableContainer
        component={Paper}
        sx={{ maxWidth: "calc(100vw - 100px)", overflowInline: "scroll" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                rowSpan={2}
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  width: "20%",
                  minWidth: "220px",
                }}
              >
                {priceTableColumnNames.name}
              </TableCell>
              <TableCell
                rowSpan={2}
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  width: "16%",
                  minWidth: "150px",
                }}
              >
                {priceTableColumnNames.place}
              </TableCell>
              <TableCell
                rowSpan={2}
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  width: "21%",
                  minWidth: "175px",
                }}
              >
                {priceTableColumnNames.size}
              </TableCell>
              <TableCell
                rowSpan={2}
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  width: "10%",
                  minWidth: "120px",
                }}
              >
                {getUnitColumnName(priceTableSetting)}
              </TableCell>
              {priceTableSetting.isUsingSellingPrice ? (
                <>
                  <TableCell
                    rowSpan={2}
                    sx={{
                      ...priceTableColumnSx,
                      backgroundColor: grey[100],
                      whiteSpace: "pre-wrap",
                      width: "14%",
                      minWidth: "120px",
                    }}
                  >
                    {priceTableColumnNames.prime_price_mark_up_rate}
                  </TableCell>
                  <TableCell
                    rowSpan={2}
                    sx={{
                      ...priceTableColumnSx,
                      backgroundColor: grey[100],
                      whiteSpace: "pre-wrap",
                      width: "14%",
                      minWidth: "120px",
                    }}
                  >
                    {priceTableColumnNames.prime_price}
                  </TableCell>
                  <TableCell
                    rowSpan={2}
                    sx={{
                      ...priceTableColumnSx,
                      backgroundColor: grey[100],
                      whiteSpace: "pre-wrap",
                      width: "14%",
                      minWidth: "120px",
                    }}
                  >
                    {priceTableColumnNames.selling_price_mark_up_rate}
                  </TableCell>
                  <TableCell
                    rowSpan={2}
                    sx={{
                      ...priceTableColumnSx,
                      backgroundColor: grey[100],
                      whiteSpace: "pre-wrap",
                      width: "14%",
                      minWidth: "120px",
                    }}
                  >
                    {priceTableColumnNames.selling_price}
                  </TableCell>
                </>
              ) : null}
              {
                priceTableSetting.isUsingDeliveryPrice       
                  ? <TableCell rowSpan={2} sx={{...priceTableColumnSx, backgroundColor: grey[100], whiteSpace: 'pre-wrap',width:"14%",  minWidth:"120px"}}>{priceTableColumnNames.delivery_price}</TableCell>
                  : null
              }
              <TableCell
                rowSpan={2}
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  whiteSpace: "pre-wrap",
                  width: "14%",
                  minWidth: "120px",
                }}
              >
                {priceTableColumnNames.unit}
              </TableCell>
              <TableCell
                rowSpan={2}
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  whiteSpace: "pre-wrap",
                  width: "14%",
                  minWidth: "150px",
                }}
              >
                {priceTableColumnNames.remarks}
              </TableCell>
              {customerShopList.map((customerShopInfo, customerIndex) => (
                <TableCell
                  colSpan={customerShopInfo.shops.length}
                  sx={{
                    ...priceTableColumnSx,
                    backgroundColor: grey[100],
                    borderLeft:
                      customerIndex > 0 ? "1px #dfdfdf solid" : "inherid",
                  }}
                >
                  {customerShopInfo.customerName}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {
                // ** 注文締め切り前に注文数を出さない対応
                // getOrderIsLimited()
                //   ? listShop.map((x)=> (
                //       <TableCell sx={{...priceTableColumnSx, backgroundColor: grey[100], whiteSpace: 'pre-wrap',width:"10%", minWidth:"100px"}}>{x.shopName}</TableCell>
                //     ))
                //   : null

                customerShopList.map((customerShopInfo, customerIndex) =>
                  customerShopInfo.shops.map((shopInfo, shopIndex) => (
                    <TableCell
                      key={shopIndex}
                      sx={{
                        ...priceTableColumnSx,
                        backgroundColor: grey[100],
                        whiteSpace: "pre-wrap",
                        width: "10%",
                        minWidth: "130px",
                        borderLeft:
                          customerIndex > 0 && shopIndex === 0
                            ? "1px #dfdfdf solid"
                            : null,
                      }}
                    >
                      {
                        priceTableSetting.isHistoryDateSpecified
                          ? <Link
                              to={SYSTEM_PATH_CUSTOMER + "/order_edit"}
                              state={getOrderEditLocationState(shopInfo.shopId, priceTableSetting.marketPriceHistoryDateInput, priceTableSetting.marketPriceId)}
                            >
                              {shopInfo.shopName}
                            </Link> 
                          : shopInfo.shopName
                      }
                      
                    </TableCell>
                  ))
                )
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((data, i) => {
              let displayData = {
                ...data,
                displayName:
                  lastName === data.productName ? "" : data.productName,
                displayOrigin:
                  lastName === data.productName &&
                  lastOrigin === data.displayOrigin
                    ? ""
                    : data.displayOrigin,
              };

              lastName = data.productName;
              lastOrigin = data.displayOrigin;

              return (
                <PriceTableRow
                  data={displayData}
                  customerShopList={customerShopList}
                  priceTableSetting={priceTableSetting}
                  key={"marketPrice_" + i.toString()}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return null;
}

// 価格表タブの内容
function PriceTableTabContent({
  dataList,
  listShop,
  tabPosition,
  priceTableSetting,
}) {
  const [page, setPage] = useState(1);

  const handleChangeTablePage = (event, page_num) => {
    setPage(page_num);
  };

  var dataMinIndex = (page - 1) * maxPriceTableRows;

  var tableData = dataList.slice(
    dataMinIndex,
    Math.min(dataMinIndex + maxPriceTableRows, dataList.length)
  );

  //タブを変更するイベント
  useEffect(() => {
    setPage(1);
    //TODO React18のバッチアップデートを除く
    setTimeout(() => {
      try {
        //ページ１をクリック
        let listPagingButton =
          document.getElementById(`paging`).children[0].children;
        listPagingButton[1].children[0].click();
      } catch {}
    }, 500);
  }, [tabPosition]);

  return (
    <Box>
      <Grid container spacing={2} marginBottom={2}>
        <Grid item xs={12}>
          <PriceEditTable
            tableData={tableData}
            listShop={listShop}
            priceTableSetting={priceTableSetting}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Pagination
            count={Math.ceil(dataList.length / maxPriceTableRows)}
            value={page}
            variant="outlined"
            shape="rounded"
            onChange={handleChangeTablePage}
            sx={{ display: "inline-block" }}
            id="paging"
          />
        </Grid>
      </Grid>
    </Box>
  );
}

// メール送信Dialog
// props ...
//   open = ダイアログを開いていればtrue
//   onClose = ダイアログを閉じるときの処理 (event) => void
//   sendProps = 送信プロパティ
function SendMailDialog({ open, onClose, sendProps }) {
  const {
    marketPriceTableInfo,
    shippingDateInfo,
    shops: initShops,
  } = sendProps;

  const [shops, setShops] = useState([]);
  const [selectDestinationDrawerOpen, setSelectDestinationDrawerOpen] =
    useState(false);

  useEffect(() => {
    if (open) {
      setSelectDestinationDrawerOpen(false);

      const customerShopInfo = getShopsGroupingByCustomer(initShops);
      const newCustomers = customerShopInfo.map((customerShopInfo) => ({
        customerId: customerShopInfo.customerId,
        customerName: customerShopInfo.customerName,
        customerEmail: customerShopInfo.shops[0].customerEmail,
        shopId: null,
        shopName: "",
        isSelected: false,
      }));

      const newShops = initShops.map((shopInfo) => ({
        ...shopInfo,
        isSelected: true,
      }));

      const newCustomerShopList = [...newCustomers, ...newShops];

      setShops(newCustomerShopList);
    }
  }, [open]);

  const today_dt = new Date();

  const officemanName = "○○";

  const mailSubject = getOrderFormMailSubject(today_dt);
  const mailText = getOrderFormMailText(
    "[取引先店舗名]",
    officemanName,
    today_dt
  );

  const getOutputMailDestination = (shopInfo) => {
    let outputDestinationArray = [];

    if (shopInfo.customerName) {
      outputDestinationArray.push(shopInfo.customerName);
    }
    if (shopInfo.shopName) {
      outputDestinationArray.push(shopInfo.shopName);
    }

    return outputDestinationArray.join("　");
  };
  // 上の内容でメール送信する　を押下時の挙動
  const onClickSendMailConfirm = async (event) => {
    let sendMailPropsList = getSelectedShopInfoList(shops).map((shopInfo) => ({
      mailFrom: "",
      mailToList: [
        shopInfo.shopEmail ? shopInfo.shopEmail : shopInfo.customerEmail,
      ],
      subject: mailSubject,
      text: getOrderFormMailText(
        getOutputMailDestination(shopInfo),
        officemanName,
        today_dt
      ),
      attachedFileInfoList: [],
    }));

    try {
      await sendMail(sendMailPropsList);
      // 出荷日更新
      await postMarketPriceUpdateShippingDateInfoAPI({
        marketPriceId: marketPriceTableInfo.marketPriceId,
        ...shippingDateInfo,
      });

      marketPriceTableInfo.shippingDateFrom = shippingDateInfo.shippingDateFrom;
      marketPriceTableInfo.shippingDateTo = shippingDateInfo.shippingDateTo;

      alert("メールを送付しました。");
      onClose(event);
    } catch (err) {
      console.log(err);
      alert("メールの送付に失敗しました。");
    }
  };

  const getSelectedShopInfoList = (shops) => {
    return shops.filter((shopInfo) => shopInfo.isSelected);
  };

  const onClickSelectDestination = (event) => {
    setSelectDestinationDrawerOpen(true);
  };

  const closeSelectDestination = (event) => {
    setSelectDestinationDrawerOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        style: {
          overflowX: "hidden",
        },
      }}
    >
      <Box padding={2}>
        <Box>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography>メールプレビュー</Typography>
            </Grid>
            <Grid item xs="auto">
              <Button variant="contained" onClick={onClickSelectDestination}>
                送信先選択
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box marginY={1} width="70vw">
          <MailPreviewWithoutMailTo
            mailSubject={mailSubject}
            mailText={mailText}
          />
        </Box>
        <Box marginTop={1}>
          <Grid container direction="row" spacing={1}>
            <Grid item xs />
            <Grid item xs="auto">
              <Button variant="outlined" onClick={onClose}>
                戻る
              </Button>
            </Grid>
            <Grid item xs="auto">
              <Button
                variant="contained"
                onClick={onClickSendMailConfirm}
                disabled={getSelectedShopInfoList(shops).length === 0}
              >
                上の内容でメール送信する
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <SelectDestinationDrawer
        open={selectDestinationDrawerOpen}
        onClose={closeSelectDestination}
        params={{
          shops: shops,
          setShops: setShops,
        }}
      />
    </Dialog>
  );
}

// 注文票確認ページ
export default function OrderFormConfirmPage() {
  const location = useLocation();
  const initMarketPriceId = location.state
    ? location.state.marketPriceId
    : null;
  let initShippingDateFrom = location.state
    ? location.state.shippingDateFrom
    : null;
  let initShippingDateTo = location.state
    ? location.state.shippingDateTo
    : null;
  const initMarketPriceHistoryDate = location.state
    ? location.state.marketPriceHistoryDate
    : null;

  const navigate = useNavigate();

  const [shippingDateInput, setShippingDateInput] = useState({
    orderDeadline: "",
    dateFrom: "",
    dateTo: "",
    isValidInterval: false,
    initialized: false,
    cleared: false,
  });

  const [tableTabPosition, setTableTabPosition] = useState(1);
  const [marketPriceInfoList, setMarketPriceInfoList] = useState([]);

  const [marketPriceTableInfoList, setMarketPriceTableInfoList] = useState([]);
  const [selectingMarketPriceTableInfo, setSelectingMarketPriceTableInfo] = useState(null);

  const [listShop, setListShop] = useState([]);

  const [sendMailDialogOpen, setSendMailDialogOpen] = useState(false);

  const [orderDeadline, setOrderDeadline] = useState("");

  const [marketPriceHistoryDateInput, setMarketPriceHistoryDateInput] = useState(initMarketPriceHistoryDate);

  const [marketPriceHistoryDateForSearch, setMarketPriceHistoryDateForSearch] = useState(initMarketPriceHistoryDate);
  const [isInitial, setInitial] = useState(true);

  const [sendProps, setSendProps] = useState({
    method: null,
    shippingDate: null,
    shippingDateInfo: {
      shippingDateFrom: "",
      shippingDateTo: "",
    },
    shops: [],
    orderFormSetting: {
      orderFormColumnDirectionCd: "1",
      orderFormShopSummaryCd: "1",
      orderFormProductTypePartitionCd: "1",
    },
  });

  const [sendFaxDialogOpen, setSendFaxDialogOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const getOrderIsLimited = () => {
    let now = new Date();
    let deadline = new Date();
    deadline.setHours(orderDeadline);
    return now >= deadline;
  };
  useEffect(() => {
    (async () => {
      //市況価格表 表データリスト取得
      let marketPriceTableInfoListRes =
        await postMarketPriceSearchTableInfoListAPI({});

      let initMarketPriceTableInfoList =
        marketPriceTableInfoListRes.marketPriceTableInfoList.map(
          (marketPriceTableInfo) => ({
            ...marketPriceTableInfo,
            primePriceMarkUpRate: marketPriceTableInfo.isUsingSellingPrice
              ? new Decimal(marketPriceTableInfo.primePriceMarkUpRate)
              : null,
            sellingPriceMarkUpRate: marketPriceTableInfo.isUsingSellingPrice
              ? new Decimal(marketPriceTableInfo.sellingPriceMarkUpRate)
              : null,
          })
        );
      
      setMarketPriceTableInfoList(initMarketPriceTableInfoList);

      // 初期表示の市況価格表データ取得
      let initMarketPriceTableInfo = null;

      if (initMarketPriceId) {
        initMarketPriceTableInfo = initMarketPriceTableInfoList.find(
          (tableInfo) => tableInfo.marketPriceId === initMarketPriceId
        );
      } else if (initMarketPriceTableInfoList.length > 0) {
        initMarketPriceTableInfo = initMarketPriceTableInfoList[0];
      }

      if (initMarketPriceTableInfo) {
        let marketPriceId = initMarketPriceTableInfo.marketPriceId;

        await loadMarketPriceInfo(
          marketPriceId,
          marketPriceHistoryDateInput,
          initShippingDateFrom,
          initShippingDateTo          
        );
      }
    })();
  }, []);

  /** 市況価格表ID, 登録日(市況価格表履歴日), 初期出荷日から、市況価格表情報をDB取得して設定する */
  const loadMarketPriceInfo = async (
    marketPriceId, marketPriceHistoryDateInput, initShippingDateFrom = null, initShippingDateTo = null
  ) => {

    const isInitial = !Boolean(marketPriceHistoryDateInput);
    
    let nextOpenDateRes = await postMarketCalendarSearchNextOpenDateInfoAPI(
      {}
    );
    let nextOpenDate = nextOpenDateRes.nextOpenDateInfo?.nextOpenDate;

    // 市況価格表履歴日を判定し, 市況価格表のリクエストパラメータを取得
    const marketPriceHistoryDate = marketPriceHistoryDateInput || nextOpenDate;

    // 市況価格表の表データの取得
    const marketPriceTableInfo = await fetchMarketPriceTableInfoList(marketPriceId, marketPriceHistoryDate, isInitial);
    
    // 検索日取得
    let marketPriceHistoryDateForSearch = marketPriceTableInfo.historyDate || marketPriceHistoryDateInput;
    let newmarketPriceHistoryDateInput = marketPriceHistoryDateInput

    if (isInitial) {
      marketPriceHistoryDateForSearch = marketPriceTableInfo.historyDate;
      newmarketPriceHistoryDateInput = marketPriceHistoryDateForSearch >= nextOpenDate ?  marketPriceHistoryDateForSearch : nextOpenDate;
    }

    initializeShippingDate(
      initShippingDateFrom || marketPriceTableInfo.shippingDateFrom,
      initShippingDateTo || marketPriceTableInfo.shippingDateTo,
      marketPriceTableInfo.shippingDateInitialSettingCd,
      newmarketPriceHistoryDateInput,
      nextOpenDate
    );

    setOrderDeadline(marketPriceTableInfo.orderDeadlineHour);
    
    // 価格表取得
    const priceInfoList = await getMarketPriceInfoList(marketPriceId, marketPriceHistoryDateForSearch, marketPriceTableInfo);

    setInitial(isInitial);
    setMarketPriceHistoryDateInput(newmarketPriceHistoryDateInput);
     
    setSelectingMarketPriceTableInfo(marketPriceTableInfo);

    //店舗リストを再取得
    setListShop(
      (await postMarketPriceShopUsingSearchInfoListAPI({ marketPriceId }))
        .marketPriceShopUsingInfoList
    );

    setMarketPriceInfoList(priceInfoList);
    setMarketPriceHistoryDateForSearch(marketPriceHistoryDateForSearch);
    setTableTabPosition(getInitialTableTabPosition(priceInfoList));
  }

  // 出荷日を初期化する
  const initializeShippingDate = async (
    initDateFrom,
    initDateTo,
    shippingDateInitialSettingCd,
    marketPriceHistoryDateInput,
    nextOpenDate
  ) => {

    let isValidInterval = true;
    let dateFrom = "";
    let dateTo = "";

    const todayDate = getHyphenedDate(new Date());
    const marketPriceHistoryDate = marketPriceHistoryDateInput || todayDate;

    if (
      (initDateFrom && initDateFrom >= marketPriceHistoryDate) ||
      (initDateTo && initDateTo >= marketPriceHistoryDate)
    ) {
      dateFrom = initDateFrom;
      dateTo = initDateTo;
    } else if (marketPriceHistoryDateInput) {
      dateFrom = marketPriceHistoryDateInput;
      if (shippingDateInitialSettingCd === 2) {
        dateTo = marketPriceHistoryDateInput;
      }
    } else if (nextOpenDate) {      
      dateFrom = nextOpenDate;
      if (shippingDateInitialSettingCd === 2) {
        dateTo = nextOpenDate;
      }
    } else {
      dateFrom = todayDate;
    }

    if (!dateTo) {
      dateTo = dateFrom;
      isValidInterval = false;
    } else if (!dateFrom) {
      dateFrom = dateTo;
      isValidInterval = false;
    }

    setShippingDateInput({
      ...shippingDateInput,
      dateFrom: dateFrom,
      dateTo: dateTo,
      isValidInterval: isValidInterval,
      initialized: true,
    });
  };

  /** 市況価格表の表データをDB取得する */
  const fetchMarketPriceTableInfoList = async (marketPriceId, marketPriceHistoryDate, isInitial = false) => {
    const searchTableInfoListParams = {marketPriceId, marketPriceHistoryDate, isInitial};

    try {
      const marketPriceTableInfoRes = await postMarketPriceSearchTableInfoListAPI(searchTableInfoListParams);

      let marketPriceTableInfo = null;

      if (marketPriceTableInfoRes.marketPriceTableInfoList.length === 0) {
        const originalTableInfo
                = marketPriceTableInfoList
                    .find((marketPriceTableInfo) => marketPriceTableInfo.marketPriceId === marketPriceId);
        
        marketPriceTableInfo = {
          ...originalTableInfo,
          shippingDateFrom: '',
          shippingDateTo: ''
        };
      } else {
        marketPriceTableInfo = marketPriceTableInfoRes.marketPriceTableInfoList[0];
      }

      return {
        ...marketPriceTableInfo,
        primePriceMarkUpRate: marketPriceTableInfo.isUsingSellingPrice
          ? new Decimal(marketPriceTableInfo.primePriceMarkUpRate)
          : null,
        sellingPriceMarkUpRate: marketPriceTableInfo.isUsingSellingPrice
          ? new Decimal(marketPriceTableInfo.sellingPriceMarkUpRate)
          : null
      };
    } catch (err) {
      if (err.response.data != "dataNotExist") {
        alert(MSG_ERR_UNEXPECTED);
      }

      return [];
    }
  }

  /** 市況価格表情報のリストを取得する */
  const getMarketPriceInfoList = async (marketPriceId, marketPriceHistoryDate, marketPriceTableInfo) => {

    const listOrderDetailParams = {
      marketPriceId,
      marketPriceHistoryDate,
      orderDateFrom : marketPriceHistoryDate,
      orderDateTo : marketPriceHistoryDate,
    }

    try {
      let orders = await getListOrderDetail(listOrderDetailParams);
      return orders.listOrderDetailInfo
        .filter((data) => data.isCustomerOrder)
        .map((data, index) => ({
          ...data,
          displaySize: getDisplaySize(
            data.rank,
            data.productClass,
            data.weight,
            data.weightUnit,
            data.packing,
            data.quantity
          ),
          displayOrigin: getDisplayOriginWithOther(
            data.origin,
            data.isOriginOther
          ),
          marketPriceInput: data.marketPrice.toLocaleString(),
          primePriceMarkUpRate: marketPriceTableInfo.isUsingSellingPrice
            ? new Decimal(data.primePriceMarkUpRate || marketPriceTableInfo.primePriceMarkUpRate)
            : null,
          primePriceMarkUpRatePercentage: marketPriceTableInfo.isUsingSellingPrice
            ? decimalToPercentDecimal(
                new Decimal(data.primePriceMarkUpRate || marketPriceTableInfo.primePriceMarkUpRate)
              ).toFixed(2) + "%"
            : null,
          primePrice: marketPriceTableInfo.isUsingSellingPrice
            ? getPrimePrice(
            	(getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd)
                   ? getDeliveryPriceCalculation(marketPriceTableInfo.deliveryPriceAdditionCd)(data.marketPrice, marketPriceTableInfo.deliveryPriceAdditionAmount)
                   : data.marketPrice
                ), data.primePriceMarkUpRate || marketPriceTableInfo.primePriceMarkUpRate)
            : null,
          isUsingSellingPrice: marketPriceTableInfo.isUsingSellingPrice,
          sellingPriceMarkUpRate: marketPriceTableInfo.isUsingSellingPrice
            ? new Decimal(data.sellingPriceMarkUpRate || marketPriceTableInfo.sellingPriceMarkUpRate)
            : null,
          sellingPriceMarkUpRatePercentage: marketPriceTableInfo.isUsingSellingPrice
            ? decimalToPercentDecimal(
                new Decimal(data.sellingPriceMarkUpRate || marketPriceTableInfo.sellingPriceMarkUpRate)
              ).toFixed(2) + "%"
            : null,
          sellingPrice: marketPriceTableInfo.isUsingSellingPrice
            ? getSellingPrice(
                (getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd)
                   ? getDeliveryPriceCalculation(marketPriceTableInfo.deliveryPriceAdditionCd)(data.marketPrice, marketPriceTableInfo.deliveryPriceAdditionAmount)
                   : data.marketPrice
                ),
                data.primePriceMarkUpRate || marketPriceTableInfo.primePriceMarkUpRate,
                data.sellingPriceMarkUpRate || marketPriceTableInfo.sellingPriceMarkUpRate
              )
            : null,
          isUsingDeliveryPrice: getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd),
          informedPrice: data.marketPrice,
          deliveryPrice: getDeliveryPriceCalculation(marketPriceTableInfo.deliveryPriceAdditionCd)(data.marketPrice, marketPriceTableInfo.deliveryPriceAdditionAmount),
          validation: true,
          isDelete: false,
          isChanged: false,
          infoListIndex: index,
        }));
    } catch (err) {
      if (err.response.data != "dataNotExist") {
        alert(MSG_ERR_UNEXPECTED);
      }

      return [];
    }
  };

  // 市況価格表データ取得後の初期タブ位置を取得する
  const getInitialTableTabPosition = (priceInfoList) => {
    if (
      priceInfoList.length === 0 ||
      priceInfoList.some((productData) => productData.priceDetailTypeId === 1)
    ) {
      return 1;
    }
    if (
      priceInfoList.some((productData) => productData.priceDetailTypeId === 2)
    ) {
      return 2;
    }
    return 3;
  };

  // エラーメッセージ取得
  const getErrorMessages = () => {
    let msgs = [];

    if (
      !isPastDate(new Date(marketPriceHistoryDateInput)) &&
      shippingDateInput.initialized &&
      stringToEmptyIfNull(shippingDateInput.dateFrom).length === 0 &&
      stringToEmptyIfNull(shippingDateInput.dateTo).length === 0
    ) {
      if (shippingDateInput.cleared) {
        msgs.push(MSG_ERR_SHIPPING_DATE_NOT_ENTERED);
      } else {
        msgs.push(MSG_ERR_SHIPPING_DATE_NOT_FOUND);
      }
    }

    return msgs;
  };

  /** 登録日変更 */
  const updateRegistratedDate = (dateInput) => {
    setShippingDateInput({
      ...shippingDateInput,
      initialized: false
    });
    setMarketPriceHistoryDateInput(dateInput);
    let marketPriceId = selectingMarketPriceTableInfo.marketPriceId;

    loadMarketPriceInfo(marketPriceId, dateInput);
  }

  // 出荷日期間指定スイッチ変更
  const onChangeShippingDateValidInterval = (event, isValidInterval) => {
    setShippingDateInput({ ...shippingDateInput, isValidInterval });
  };

  // 出荷日期間変更
  const updateShippingDateInterval = (prop) => (date) => {
    let newShippingDateInput = { ...shippingDateInput };
    newShippingDateInput[prop] = date;
    setShippingDateInput(newShippingDateInput);
  };

  const handleChangeTab = (event, tabPos) => {
    setTableTabPosition(tabPos);
  };

  const onClickSendMail =
    (marketPriceTableInfo, listShop, shippingDateInput) => (event) => {

      setSendProps({
        method: "mail",
        shippingDateInfo: getActualShippingDateInfo(
          shippingDateInput.dateFrom,
          shippingDateInput.dateTo,
          shippingDateInput.isValidInterval
        ),
        marketPriceTableInfo: marketPriceTableInfo,
        shops: listShop,
      });
      setSendMailDialogOpen(true);
    };

  const onCloseSendMailDialog = async (event) => {
    setSendMailDialogOpen(false);
  };

  const onClickSendFax =
    (marketPriceTableInfo, listShop, shippingDateInput) => (event) => {

      setSendProps({
        method: "fax",
        shippingDateInfo: getActualShippingDateInfo(
          shippingDateInput.dateFrom,
          shippingDateInput.dateTo,
          shippingDateInput.isValidInterval
        ),
        marketPriceTableInfo: {
          ...marketPriceTableInfo,
          marketPriceHistoryDate: marketPriceHistoryDateForSearch
        },
        shops: listShop,
        onlyPdf: false,
      });
      setSendFaxDialogOpen(true);
    };

  const onClickPdfPreview =
    (marketPriceTableInfo, listShop, shippingDateInput) => (event) => {

      setSendProps({
        method: "fax",
        shippingDateInfo: 
          isPastDate(new Date(marketPriceHistoryDateInput))
          ? {
            shippingDateFrom: marketPriceHistoryDateInput,
            shippingDateTo: marketPriceHistoryDateInput,
          }
          : getActualShippingDateInfo(
              shippingDateInput.dateFrom,
              shippingDateInput.dateTo,
              shippingDateInput.isValidInterval
            ),
        marketPriceTableInfo: {
          ...marketPriceTableInfo,
          marketPriceHistoryDate: marketPriceHistoryDateInput == marketPriceHistoryDateForSearch ? marketPriceHistoryDateInput: null
        },
        shops: listShop,
        onlyPdf: true,
      });
      setSendFaxDialogOpen(true);
    };

  const onCloseSendFaxDialog = (event) => {
    setSendFaxDialogOpen(false);
  };

  /** 市況価格表変更時処理 */
  const handleChangeSelectingMarketPrice = async (event) => {

    let marketPriceIdValue = event.target.value;
    let marketPriceId = inputValueToInt(marketPriceIdValue);

    navigate(SYSTEM_PATH_COMPANY + "/order_form_confirm", {
      state: { marketPriceId },
      replace: true,
    });

    await loadMarketPriceInfo(marketPriceId, null);
  };

  // 価格表出力設定を取得する
  const getPriceTableSetting = (marketPriceTableInfo) => {
    if (marketPriceTableInfo) {
      return {
        marketPriceId: marketPriceTableInfo.marketPriceId,
        unitPriceCd: marketPriceTableInfo.unitPriceCd,
        isUsingSellingPrice: marketPriceTableInfo.isUsingSellingPrice,
        isUsingDeliveryPrice: marketPriceTableInfo.deliveryPriceAdditionCd !== DELIVERY_PRICE_ADDITION_CD_NONE,
        getDeliveryPrice: getDeliveryPriceCalculation(marketPriceTableInfo.deliveryPriceAdditionCd),
        marketPriceHistoryDateInput: marketPriceHistoryDateForSearch,
        isHistoryDateSpecified: marketPriceHistoryDateForSearch == marketPriceHistoryDateInput
      };
    }

    return {};
  };

  const onClickEdit = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/market_price_edit", {
      state: getMarketPriceEditLocationState(
        selectingMarketPriceTableInfo.marketPriceId,
        getActualShippingDateInfo(
          shippingDateInput.dateFrom,
          shippingDateInput.dateTo,
          shippingDateInput.isValidInterval
        ),
        marketPriceHistoryDateForSearch,
        isInitial
      ),
    });
  };

  let orderIsLimited = getOrderIsLimited();
    
  const isDeveloper = checkIsDeveloper();

  return (
    <CompanyTitledPage title="注文票確認">
      <ErrorMessageBox messages={getErrorMessages()} />
      <LoadingModal open={isLoading} label="送信中" />
      <Box>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Typography fontSize={20}>市況価格表名 :</Typography>
          </Grid>
          <Grid item>
            <Select
              value={selectingMarketPriceTableInfo ? selectingMarketPriceTableInfo.marketPriceId.toString() : ""}
              onChange={handleChangeSelectingMarketPrice}
              sx={{ minWidth: 200, fontSize: 20 }}
            >
              {marketPriceTableInfoList.map((tableInfo, i) => {
                return (
                  <MenuItem
                    key={`marketPrice_${i}`}
                    value={tableInfo.marketPriceId.toString()}
                  >
                    {tableInfo.marketPriceName}
                  </MenuItem>
                );
              })}
            </Select>
          </Grid>
          {isDeveloper &&
            <Grid item>
              <Button 
                variant="contained"
                onClick={() => {
                  navigate(
                    "/company/market_price_setting_edit",
                    {
                      state: {
                        marketPriceId: selectingMarketPriceTableInfo.marketPriceId
                      },
                    }
                  )
                }}
                fontSize={20}
                sx={{minWidth: 0}}
              >
                設定変更
              </Button>
            </Grid>
          }
          <Grid item marginLeft={5}>
            <Typography sx={{ fontSize: 20 }}>
              表示対象出荷日 :
            </Typography>
          </Grid>
          <Grid item>
            <DateInput
              value={marketPriceHistoryDateInput}
              setValue={updateRegistratedDate}
            />
          </Grid>
          {
            isDeveloper &&
              <Grid item ml="auto">
                <Button 
                  variant="contained"
                  onClick={() => {
                    navigate("/company/market_price_register/")
                  }}
                  fontSize={20}
                >
                  市況価格表登録
                </Button>
              </Grid>
          } 
        </Grid>
      </Box>

      <Box my={1}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          display="flex"
          justifyContent="flex-end"
        >
          <Grid item>
            <Typography sx={{ fontSize: 20, textAlign: "right" }}>
              出荷日 :
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <DateInput
              value={shippingDateInput.dateFrom}
              setValue={updateShippingDateInterval("dateFrom")}
              disabled={isPastDate(new Date(marketPriceHistoryDateInput))}
            />
          </Grid>
          <Grid
            item
            xs="auto"
            display={shippingDateInput.isValidInterval ? "inherid" : "none"}
          >
            ～
          </Grid>
          <Grid
            item
            xs="auto"
            display={shippingDateInput.isValidInterval ? "inherid" : "none"}
          >
            <DateInput
              value={shippingDateInput.dateTo}
              setValue={updateShippingDateInterval("dateTo")}
              disabled={isPastDate(new Date(marketPriceHistoryDateInput))}
            />
          </Grid>
          <Grid item xs="auto">
            <Switch
              checked={shippingDateInput.isValidInterval}
              onChange={onChangeShippingDateValidInterval}
              disabled={isPastDate(new Date(marketPriceHistoryDateInput))}
            />
            期間で指定
          </Grid>
        </Grid>
      </Box>

      <Box marginTop={2} marginBottom={2}>
        <Grid container alignItems="baseline" spacing={2}>
          <Grid item xs>
            <Tabs value={tableTabPosition} onChange={handleChangeTab}>
              <Tab label="蔬菜" value={1} />
              <Tab label="果物" value={2} />
              <Tab label="スポット" value={3} />
            </Tabs>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={onClickEdit}
              disabled={isPastDate(new Date(marketPriceHistoryDateInput))}
            >
              編集
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={onClickSendMail(
                selectingMarketPriceTableInfo,
                listShop,
                shippingDateInput
              )}
              disabled={marketPriceInfoList.length === 0 || isPastDate(new Date(marketPriceHistoryDateInput))}
            >
              注文票メール送信
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={onClickSendFax(
                selectingMarketPriceTableInfo,
                listShop,
                shippingDateInput
              )}
              disabled={marketPriceInfoList.length === 0 || isPastDate(new Date(marketPriceHistoryDateInput))}
            >
              注文票FAX用印刷
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={onClickPdfPreview(
                selectingMarketPriceTableInfo,
                listShop,
                shippingDateInput
              )}
              disabled = {marketPriceInfoList.length === 0 || marketPriceHistoryDateForSearch !== marketPriceHistoryDateInput}
            >
              注文数PDF作成
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <PriceTableTabContent
          tabPosition={tableTabPosition}
          dataList={marketPriceInfoList.filter(
            (data) => data.priceDetailTypeId === tableTabPosition
          )}
          listShop={listShop}
          priceTableSetting={getPriceTableSetting(selectingMarketPriceTableInfo)}
        />
      </Box>
      <SendMailDialog
        open={sendMailDialogOpen}
        onClose={onCloseSendMailDialog}
        sendProps={sendProps}
      />
      <SendFaxDialog
        open={sendFaxDialogOpen}
        onClose={onCloseSendFaxDialog}
        sendProps={sendProps}
        setIsLoading={setIsLoading}
      />
    </CompanyTitledPage>
  );
}
